import { TicketPriority } from '../models/AreaPriorities'
import { TicketRepository } from '../repositories/TicketRepository'

export function CreateAssignPriorityCase(ticketRepository: TicketRepository) {
  return async function ({
    priority,
    ticketId
  }: {
    ticketId: string
    priority: TicketPriority
  }) {
    return await ticketRepository.createAssignPriority({ priority, ticketId })
  }
}
